class BESSAppProjectEditorSelectField extends BESSAppProjectEditorInputField {

    constructor(editor, item, field) {
        super(editor, item, field);
        this.placeholder = field.placeholder;
        if (!this.placeholder) {
            this.placeholder = 'Please select';
        }
    }

    initialise() {
        super.initialise();
        if (this._addChangeHandler()) {
            this.input.onChangeKeyUp(this, this._inputChanged);
        }
    }

    _templateForInput() {
        return "<select class='form-select field-editor app-validation-parent'></select>"
    }

    _configureView(node) {
        let select = node.find('select');
        this.input = select;
        select.attr('name', this.field.label);
        if (this.field.isRequired) {
            select.attr('required', 'required');
        }

        this._addChoices();
    }

    _addChoice(key, value, isSelected) {
        isSelected = falseIfUndefined(isSelected)
        let option = $('<option></option>').attr('value', key).html(value);
        if (isSelected) {
            option.attr('selected', 'selected');
        }
        this.input.append(option);
    }

    _removeChoice(key) {
        this.input.find('option[value="' + key + '"]').remove();
    }

    _addChoices() {

    }


    onFieldDependencyChanged(isAvailable, value) {
        this.forEach(this.field.choices, function (choiceData) {

            if (choiceData.dependencyQuestionValue !== null) {
                let showChoice = this.shouldShowChoice(choiceData, value);
                this.input.find('option[value="' + choiceData.key + '"]').enableIf(showChoice);
            }

        });
    }

    shouldShowChoice(choiceData, value) {
        if (choiceData.dependencyQuestionValue.indexOf(',') >= 0) {
            let values = choiceData.dependencyQuestionValue.split(',');
            return values.indexOf(value) >= 0;
        } else if (choiceData.dependencyQuestionValue[0] === '!') {
            return choiceData.dependencyQuestionValue.substring(1) !== value;
        }
        return choiceData.dependencyQuestionValue === value;
    };
}

class BESSAppProjectEditorChoiceField extends BESSAppProjectEditorSelectField {

    constructor(editor, item, field) {
        super(editor, item, field);
        this.choice = this.value.getChoice(field);
    }

    matchValue(value) {
        value = ('' + value).toLowerCase();
        let bestMatch = null;
        let exactMatch = false;
        _.each(this.field.choices, function (choice) {
            let choiceValue = choice.value.toLowerCase();
            if (choiceValue === value) {
                bestMatch = choice;
                exactMatch = true;
            } else if (!exactMatch &&
                (choiceValue.indexOf(value) !== -1 || value.indexOf(choiceValue) !== -1)) {
                bestMatch = choice;
            }
        });
        if (bestMatch) {
            this.setValue(bestMatch);
            return true;
        }
        return false;
    }

    setValue(value) {
        super.setValue(value);
        if(value !== null) {
            this.input.val(value.key);
        }
    }

    clear() {
        this.setValue({key: "-1"});
        this.value.value = "";
    }


    setValueIsChanged(value) {
        if (this.choice === null) {
            return value != null;
        }
        return value !== this.choice.key;
    }

    _toDataValue(value) {
        if (value == null) return null;
        return value.key;
    }

    _getInputValue() {
        let key = super._getInputValue();
        let value = null;
        _.each(this.field.choices, function (choice) {
            if (choice.key === key) {
                value = choice;
            }
        });
        return value;
    }

    _configureView(node) {
        super._configureView(node);

        if (this.choice !== undefined && this.choice != null) {
            this.input.attr('value', this.choice.key);
        }
    }

    _addChoices() {
        if (this.choice === null) {
            this._addChoice(-1, this.placeholder, true);
        }
        _.each(this.field.choices, function (choice) {
            this._addChoice(choice.key, choice.value, choice === this.choice);
        }.bind(this));
    }


}